<template>
  <div>
    <div v-if="copy && parents && cornerstones">
      <h1>
        Article
        <span v-if="copy.articleId">{{ copy.articleId }}</span>
      </h1>
      <v-card>
        <v-form ref="articleForm" v-model="valid" lazy-validation>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="copy.articleId"
                  label="Article id"
                  outline
                  readonly
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="copy.parentId"
                  :items="parents"
                  label="Parent article"
                  item-text="pageName"
                  item-value="articleId"
                  outline
                  append-outer-icon="create"
                  @click:append-outer="copy.parentId = 1626"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="copy.adBar"
                  :items="adBars"
                  label="Ad bar"
                  item-text="name"
                  item-value="id"
                  outline
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field v-model="copy.heading" label="Heading" outline />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="copy.pageName"
                  label="Page name"
                  outline
                  append-icon="create"
                  @click:append="slugifyHeading"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="copy.title"
                  label="Meta title"
                  outline
                  append-icon="create"
                  @click:append="copyHeading"
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  v-model="copy.keyWords"
                  label="Meta keywords"
                  outline
                  required
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  v-model="copy.description"
                  label="Description"
                  outline
                  required
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  v-model="copy.blurb"
                  label="Blurb"
                  outline
                  required
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-btn-toggle v-model="editorMode" mandatory>
                  <v-btn flat small value="source">Source</v-btn>
                  <v-btn flat small value="rich">Richtext</v-btn>
                </v-btn-toggle>
                <quill-editor v-model="copy.body" v-if="editorMode == 'rich'" />
                <v-textarea
                  v-model="copy.body"
                  v-if="editorMode == 'source'"
                  label="Body"
                  outline
                  required
                  auto-grow
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  prepend-icon="location_on"
                  v-model="copy.latitude"
                  label="Latitude"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  prepend-icon="location_on"
                  v-model="copy.longitude"
                  label="Longitude"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox v-model="copy.vw96" label="Vw96" />
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox v-model="copy.exclude" label="Exclude" />
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox v-model="copy.excludeHtml" label="Exclude html" />
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox v-model="copy.archived" label="Archived" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  prepend-icon="event"
                  v-model="copy.created"
                  :hint="computedDateFormattedMomentjs"
                  label="Created"
                  readonly
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-select
                  v-model="cornerstonesSelected"
                  :items="cornerstones"
                  item-text="heading"
                  item-value="articleId"
                  attach
                  chips
                  label="Cornerstones"
                  multiple
                ></v-select>
              </v-flex>
              <v-flex xs12 md12 v-if="rulesets">
                <v-select
                  v-model="copy.rulesetid"
                  :items="rulesets"
                  label="Rule set calculator"
                  item-text="heading"
                  item-value="id"
                  outline
                  append-outer-icon="delete"
                  @click:append-outer="copy.rulesetid = null"
                />
              </v-flex>
              <v-flex xs12 md12>
                <v-select
                  v-model="imagecollectionid"
                  :items="imageCollections"
                  label="Image collection"
                  item-text="name"
                  item-value="id"
                  outline
                  v-if="imageCollections"
                />
                <v-select
                  v-model="copy.imageid"
                  :items="images"
                  label="Images"
                  item-text="name"
                  item-value="id"
                  outline
                  v-if="images"
                  append-outer-icon="delete"
                  @click:append-outer="copy.imageid = null"
                />
                <v-img :src="image.path" aspect-ratio="1" v-if="image" />
              </v-flex>
              <v-flex xs12 md12>
                <v-btn color="info" @click="save">SAVE</v-btn>
                <v-btn flat color="info" :to="{ name: 'articles' }"
                  >Cancel</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
      <v-btn v-if="computedArticleLink" @click="openDirectLink">
        View article on client website
      </v-btn>
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { format, parseISO } from "date-fns";
import slugify from "slugify";
export default {
  name: "ArticleForm",
  computed: {
    computedDateFormattedMomentjs() {
      return this.article && this.article.created
        ? format(parseISO(this.article.created), "EEEE, MMMM do yyyy")
        : "";
    },
    computedArticleLink() {
      if (!this.article) {
        return undefined;
      }
      return `${process.env.VUE_APP_NBM_URL}/${this.article.pageName}.htm`;
    },
  },
  data() {
    return {
      valid: false,
      article: null,
      copy: null,
      editorMode: "rich",
      parents: [],
      articleCornerstones: null,
      cornerstones: [],
      cornerstonesSelected: [],
      adBars: [
        {
          id: 0,
          name: "None",
        },
        {
          id: 1,
          name: "Quote bar + right bar (default)",
        },
        {
          id: 2,
          name: "Quote ad",
        },
        {
          id: 3,
          name: "Quote ad + testimonials",
        },
        {
          id: 4,
          name: "Quote bar",
        },
        {
          id: 5,
          name: "Quote bar + twitter",
        },
      ],
      imageCollections: null,
      imagecollectionid: null,
      images: null,
      image: null,
      rulesets: null,
    };
  },
  methods: {
    async fetchArticle() {
      this.article = null;
      const response = await nbmlaw.get(
        `/cors/admin/extras/articles/${this.$route.params.id}`
      );
      // console.log(response.data)
      this.article = response.data;
    },
    async fetchArticleCornerstones() {
      const response = await nbmlaw.get(
        `/cors/admin/extras/articles/${this.$route.params.id}/cornerstones`
      );
      // console.log(response.data)
      this.articleCornerstones = response.data;
    },
    slugifyHeading() {
      this.copy.pageName = slugify(this.copy.heading, {
        replacement: "-",
        remove: /[*+~.()'"!:@]/g,
        lower: true,
      });
    },
    copyHeading() {
      this.copy.title = this.copy.heading;
    },
    async fetchParents() {
      const response = await nbmlaw.get(`/cors/admin/extras/parents`);
      // console.log(response.data)
      this.parents = response.data;
    },
    async fetchCornerstones() {
      const response = await nbmlaw.get(`/cors/admin/extras/cornerstones`);
      // console.log(response.data)
      this.cornerstones = response.data;
    },
    async fetchImageCollections() {
      const response = await nbmlaw.get(`/cors/admin/image/imageCollections`);
      // console.log(response.data);
      this.imageCollections = response.data;
    },
    async fetchImages() {
      const response = await nbmlaw.get(
        `/cors/admin/image/imageCollections/${this.imagecollectionid}/images`
      );
      // console.log(response.data);
      this.images = response.data;
    },
    async fetchImage() {
      const response = await nbmlaw.get(
        `/cors/admin/image/images/${this.copy.imageid}`
      );
      // console.log(response.data);
      this.image = response.data;
    },
    async fetchRulesets() {
      const response = await nbmlaw.get(`/cors/admin/sales/rulesets`);
      // console.log(response.data)
      this.rulesets = response.data;
    },
    save() {
      if (this.$refs.articleForm.validate()) {
        if (this.$route.params.id) {
          this.updateArticle();
        } else {
          this.createArticle();
        }
      }
    },
    async createArticle() {
      const response = await nbmlaw.post(
        `/cors/admin/extras/articles`,
        this.copy
      );
      // console.log(response.data)
      await nbmlaw.put(
        `/cors/admin/extras/articles/${response.data}/cornerstones`,
        this.cornerstonesSelected
      );
      this.$router.push({
        name: "articles",
      });
    },
    async updateArticle() {
      // console.log(article);
      await nbmlaw.put(
        `/cors/admin/extras/articles/${this.$route.params.id}`,
        this.copy
      );
      // console.log(response.data)
      await nbmlaw.put(
        `/cors/admin/extras/articles/${this.$route.params.id}/cornerstones`,
        this.cornerstonesSelected
      );
      this.$router.push({
        name: "articles",
      });
    },
    openDirectLink() {
      window.open(this.computedArticleLink, "_blank");
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchArticle();
          this.fetchArticleCornerstones();
        } else {
          this.copy = {
            parentId: 28,
            adBar: 1,
            heading: null,
            pageName: null,
            title: null,
            keyWords: null,
            description: null,
            blurb: null,
            body: null,
            latitude: null,
            longitude: null,
            vw96: false,
            exclude: false,
            excludeHtml: false,
            archived: false,
            cornerstoneList: [],
            rulesetid: null,
          };
          this.cornerstonesSelected = [];
        }
      },
    },
    imagecollectionid: {
      handler() {
        if (this.imagecollectionid) {
          this.fetchImages();
        } else {
          this.images = null;
        }
      },
    },
    article: {
      handler() {
        this.copy = JSON.parse(JSON.stringify(this.article));
      },
    },
    articleCornerstones: {
      handler() {
        this.cornerstonesSelected = JSON.parse(
          JSON.stringify(this.articleCornerstones)
        );
      },
    },
    copy: {
      handler() {
        if (this.copy.imageid) {
          this.fetchImage();
        } else {
          this.image = null;
        }
      },
      deep: true,
    },
    image: {
      handler() {
        if (this.image) {
          this.imagecollectionid = this.image.imagecollectionid;
        }
      },
    },
  },
  created() {
    this.fetchParents();
    this.fetchCornerstones();
    this.fetchImageCollections();
    this.fetchRulesets();
  },
};
</script>
